import { TurnSet } from './TurnSet';

export class TurnSetWithSelections {
	public readonly turnSet: TurnSet;
	public readonly playerSelectionsMade: boolean[];

	constructor(turnSet: TurnSet, playerSelectionsMade: boolean[]) {
		this.turnSet = turnSet;
		this.playerSelectionsMade = playerSelectionsMade;
	}

	public static fromJSON(json: string): TurnSetWithSelections {
		// Remove all spaces - different broswers handle whitespace differently when saving/getting json string from cookie!
		json = json.replace(/\s/g, '');

		const turnsJSON = json.substring(8, json.indexOf(',"playerSelectionsMade"'));
		const playerSelectionsMadeJSON = json.substring(json.indexOf('playerSelectionsMade') + 22);

		const turnSetWithMethods = TurnSet.fromJSON(turnsJSON);
		const playerSelectionsMade = <boolean[]>JSON.parse(playerSelectionsMadeJSON);

		const withMethods = new TurnSetWithSelections(turnSetWithMethods, playerSelectionsMade);
		return withMethods;
	}

	public toJSON = (): string => {
		return `"turns": ${this.turnSet.toJSON()}, "playerSelectionsMade": ${JSON.stringify(this.playerSelectionsMade)}`;
	};
}
